import { api } from "@/lib/api-client";

export type LoginPayload = {
  email: string;
  password: string;
  remember?: boolean;
};

export type CompanyOption = {
  id: string;
  name: string;
  slug: string;
  role: string;
  is_active: boolean;
  logo: string | null;
};

export type LoginResponse = {
  access_token?: string;
  expires_at?: number;
  user_id: string;
  company_id?: string;
  company_name?: string;
  email: string;
  role?: string;
  // Multi-empresa fields
  require_company_selection?: boolean;
  temp_token?: string;
  companies?: CompanyOption[];
  first_name?: string;
};

export type UserSession = {
  user_id: string;
  company_id: string;
  company_name: string;
  email: string;
  role: string;
};

export async function login(payload: LoginPayload): Promise<LoginResponse> {
  const response = await api.post("auth/login", { json: payload }).json<LoginResponse>();

  // Solo almacenar JWT si es login directo (no multi-empresa)
  if (response.access_token && !response.require_company_selection) {
    localStorage.setItem('abbi_token', response.access_token);
  }

  return response;
}

export async function selectCompany(companyId: string, tempToken: string): Promise<LoginResponse> {
  const response = await api.post("auth/select-company", {
    json: { company_id: companyId },
    headers: {
      Authorization: `Bearer ${tempToken}`,
    },
  }).json<LoginResponse>();

  // Almacenar JWT completo tras selección
  if (response.access_token) {
    localStorage.setItem('abbi_token', response.access_token);
  }

  return response;
}

export async function fetchSession(): Promise<UserSession> {
  const { apiWithAuth } = await import("@/lib/api-client");
  const response = await apiWithAuth.get("auth/me").json<UserSession>();
  return response;
}

export async function logout(): Promise<void> {
  const { apiWithAuth } = await import("@/lib/api-client");
  await apiWithAuth.post("auth/logout");
}
